var map = {
	"./symbol_0.png": 32780,
	"./symbol_1.png": 99317,
	"./symbol_2.png": 13566,
	"./symbol_3.png": 1255,
	"./symbol_4.png": 9736,
	"./symbol_5.png": 66033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11207;